import { render, staticRenderFns } from "./custormQuery.vue?vue&type=template&id=74fee6c8&scoped=true&"
import script from "./custormQuery.vue?vue&type=script&lang=js&"
export * from "./custormQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fee6c8",
  null
  
)

export default component.exports